/**
 * Algerian wilayas (provinces) + their major communes (municipalities).
 *
 * Compact reference: 58 wilayas with the top-population/most-used communes.
 * Use `getCommunes(wilayaCode)` for the dropdown filter.
 *
 * Source: official 58 wilayas (2024 administrative split).
 */

export const WILAYAS = [
  { code: '01', name_ar: 'أدرار',           name_fr: 'Adrar' },
  { code: '02', name_ar: 'الشلف',           name_fr: 'Chlef' },
  { code: '03', name_ar: 'الأغواط',         name_fr: 'Laghouat' },
  { code: '04', name_ar: 'أم البواقي',      name_fr: 'Oum El Bouaghi' },
  { code: '05', name_ar: 'باتنة',           name_fr: 'Batna' },
  { code: '06', name_ar: 'بجاية',           name_fr: 'Béjaïa' },
  { code: '07', name_ar: 'بسكرة',           name_fr: 'Biskra' },
  { code: '08', name_ar: 'بشار',            name_fr: 'Béchar' },
  { code: '09', name_ar: 'البليدة',         name_fr: 'Blida' },
  { code: '10', name_ar: 'البويرة',         name_fr: 'Bouira' },
  { code: '11', name_ar: 'تمنراست',         name_fr: 'Tamanrasset' },
  { code: '12', name_ar: 'تبسة',            name_fr: 'Tébessa' },
  { code: '13', name_ar: 'تلمسان',          name_fr: 'Tlemcen' },
  { code: '14', name_ar: 'تيارت',           name_fr: 'Tiaret' },
  { code: '15', name_ar: 'تيزي وزو',        name_fr: 'Tizi Ouzou' },
  { code: '16', name_ar: 'الجزائر',         name_fr: 'Alger' },
  { code: '17', name_ar: 'الجلفة',          name_fr: 'Djelfa' },
  { code: '18', name_ar: 'جيجل',            name_fr: 'Jijel' },
  { code: '19', name_ar: 'سطيف',            name_fr: 'Sétif' },
  { code: '20', name_ar: 'سعيدة',           name_fr: 'Saïda' },
  { code: '21', name_ar: 'سكيكدة',          name_fr: 'Skikda' },
  { code: '22', name_ar: 'سيدي بلعباس',     name_fr: 'Sidi Bel Abbès' },
  { code: '23', name_ar: 'عنابة',           name_fr: 'Annaba' },
  { code: '24', name_ar: 'قالمة',           name_fr: 'Guelma' },
  { code: '25', name_ar: 'قسنطينة',         name_fr: 'Constantine' },
  { code: '26', name_ar: 'المدية',          name_fr: 'Médéa' },
  { code: '27', name_ar: 'مستغانم',         name_fr: 'Mostaganem' },
  { code: '28', name_ar: 'المسيلة',         name_fr: 'M\'Sila' },
  { code: '29', name_ar: 'معسكر',           name_fr: 'Mascara' },
  { code: '30', name_ar: 'ورقلة',           name_fr: 'Ouargla' },
  { code: '31', name_ar: 'وهران',           name_fr: 'Oran' },
  { code: '32', name_ar: 'البيض',           name_fr: 'El Bayadh' },
  { code: '33', name_ar: 'إليزي',           name_fr: 'Illizi' },
  { code: '34', name_ar: 'برج بوعريريج',    name_fr: 'Bordj Bou Arréridj' },
  { code: '35', name_ar: 'بومرداس',         name_fr: 'Boumerdès' },
  { code: '36', name_ar: 'الطارف',          name_fr: 'El Tarf' },
  { code: '37', name_ar: 'تندوف',           name_fr: 'Tindouf' },
  { code: '38', name_ar: 'تيسمسيلت',        name_fr: 'Tissemsilt' },
  { code: '39', name_ar: 'الوادي',          name_fr: 'El Oued' },
  { code: '40', name_ar: 'خنشلة',           name_fr: 'Khenchela' },
  { code: '41', name_ar: 'سوق أهراس',       name_fr: 'Souk Ahras' },
  { code: '42', name_ar: 'تيبازة',          name_fr: 'Tipaza' },
  { code: '43', name_ar: 'ميلة',            name_fr: 'Mila' },
  { code: '44', name_ar: 'عين الدفلى',      name_fr: 'Aïn Defla' },
  { code: '45', name_ar: 'النعامة',         name_fr: 'Naâma' },
  { code: '46', name_ar: 'عين تموشنت',      name_fr: 'Aïn Témouchent' },
  { code: '47', name_ar: 'غرداية',          name_fr: 'Ghardaïa' },
  { code: '48', name_ar: 'غليزان',          name_fr: 'Relizane' },
  { code: '49', name_ar: 'المغير',          name_fr: 'El M\'Ghair' },
  { code: '50', name_ar: 'المنيعة',         name_fr: 'El Menia' },
  { code: '51', name_ar: 'أولاد جلال',      name_fr: 'Ouled Djellal' },
  { code: '52', name_ar: 'برج باجي مختار',   name_fr: 'Bordj Badji Mokhtar' },
  { code: '53', name_ar: 'بني عباس',        name_fr: 'Béni Abbès' },
  { code: '54', name_ar: 'تيميمون',          name_fr: 'Timimoun' },
  { code: '55', name_ar: 'تقرت',            name_fr: 'Touggourt' },
  { code: '56', name_ar: 'جانت',             name_fr: 'Djanet' },
  { code: '57', name_ar: 'عين صالح',         name_fr: 'In Salah' },
  { code: '58', name_ar: 'عين قزام',         name_fr: 'In Guezzam' },
];

// Most-used communes per wilaya (kept compact; expand as needed).
export const COMMUNES = {
  '01': ['أدرار', 'تيميمون', 'رقان', 'فنوغيل', 'تيت'],
  '02': ['الشلف', 'تنس', 'وادي الفضة', 'بوقادير', 'أولاد فارس'],
  '03': ['الأغواط', 'أفلو', 'الحويطة', 'سيدي مخلوف'],
  '04': ['أم البواقي', 'عين البيضاء', 'عين فكرون', 'مسكيانة', 'سوق نعمان'],
  '05': ['باتنة', 'بريكة', 'عين التوتة', 'مروانة', 'تازولت', 'نقاوس'],
  '06': ['بجاية', 'أقبو', 'أميزور', 'تيمزريت', 'سيدي عيش', 'تيشي'],
  '07': ['بسكرة', 'سيدي عقبة', 'طولقة', 'أورلال', 'أوماش'],
  '08': ['بشار', 'بني عباس', 'القنادسة', 'تاغيت'],
  '09': ['البليدة', 'بوفاريك', 'الأربعاء', 'موزاية', 'وادي العلايق', 'العفرون'],
  '10': ['البويرة', 'سور الغزلان', 'الأخضرية', 'عين بسام', 'برج أوخريص'],
  '11': ['تمنراست', 'عين صالح', 'تين زاوتين', 'إديلس'],
  '12': ['تبسة', 'الشريعة', 'بئر العاتر', 'الونزة', 'مرسط'],
  '13': ['تلمسان', 'مغنية', 'الرمشي', 'ندرومة', 'صبرة', 'هنين'],
  '14': ['تيارت', 'سوقر', 'فرندة', 'مهدية', 'قصر الشلالة'],
  '15': ['تيزي وزو', 'عزازقة', 'بوزقن', 'تيقزيرت', 'ذراع الميزان', 'ماكودة'],
  '16': ['الجزائر الوسطى', 'باب الواد', 'بئر مراد رايس', 'الحراش', 'الدار البيضاء', 'بئر خادم', 'حسين داي', 'باش جراح', 'القبة', 'بئر توتة', 'زرالدة', 'الشراقة', 'بن عكنون', 'حيدرة', 'سيدي عبد الله'],
  '17': ['الجلفة', 'حاسي بحبح', 'دلدول', 'مسعد', 'عين وسارة', 'حد الصحاري'],
  '18': ['جيجل', 'الميلية', 'الطاهير', 'العنصر', 'تكسنة'],
  '19': ['سطيف', 'العلمة', 'عين ولمان', 'بئر العرش', 'بوقاعة', 'عين الكبيرة'],
  '20': ['سعيدة', 'عين الحجر', 'يوب', 'عين سخونة'],
  '21': ['سكيكدة', 'القل', 'عزابة', 'الحدائق', 'تمالوس', 'الحروش'],
  '22': ['سيدي بلعباس', 'تلاغ', 'مرحوم', 'بن باديس', 'بئر الحمام'],
  '23': ['عنابة', 'البوني', 'الحجار', 'سيدي عمار', 'برحال'],
  '24': ['قالمة', 'بومهرة أحمد', 'هيليوبوليس', 'عين العربي', 'بوحمدان'],
  '25': ['قسنطينة', 'الخروب', 'حامة بوزيان', 'زيغود يوسف', 'عين عبيد', 'ابن باديس'],
  '26': ['المدية', 'بني سليمان', 'تابلاط', 'القلب الكبير', 'البرواقية', 'عزيز'],
  '27': ['مستغانم', 'سيدي علي', 'عشعاشة', 'حاسي ماماش', 'ماسرى'],
  '28': ['المسيلة', 'بوسعادة', 'حمام الضلعة', 'مقرة', 'سيدي عيسى', 'عين الملح'],
  '29': ['معسكر', 'تيغنيف', 'سيق', 'محمدية', 'وادي الأبطال', 'غريس'],
  '30': ['ورقلة', 'تقرت', 'حاسي مسعود', 'الرويسات', 'تماسين'],
  '31': ['وهران', 'بئر الجير', 'السانية', 'أرزيو', 'الكرمة', 'بطيوة', 'حاسي بونيف', 'سيدي الشحمي'],
  '32': ['البيض', 'بوقطب', 'الرقاصة', 'الأبيض سيدي الشيخ', 'بريزينة'],
  '33': ['إليزي', 'جانت', 'دبداب', 'برج الحواس'],
  '34': ['برج بوعريريج', 'رأس الوادي', 'المنصورة', 'المهير', 'العناصر'],
  '35': ['بومرداس', 'برج منايل', 'دلس', 'ناصرية', 'بودواو', 'الثنية', 'خميس الخشنة'],
  '36': ['الطارف', 'القالة', 'الذرعان', 'بن مهيدي', 'بوحجار'],
  '37': ['تندوف', 'أم العسل'],
  '38': ['تيسمسيلت', 'بردج بونعامة', 'لرجام', 'لزرارقة', 'خميستي'],
  '39': ['الوادي', 'قمار', 'كوينين', 'الدبيلة', 'بياضة', 'رباح'],
  '40': ['خنشلة', 'قايس', 'بابار', 'تاورة', 'الرميلة'],
  '41': ['سوق أهراس', 'سدراتة', 'تاورة', 'مداوروش', 'الحدادة'],
  '42': ['تيبازة', 'القليعة', 'حجوط', 'شرشال', 'دواودة', 'سيدي راشد'],
  '43': ['ميلة', 'فرجيوة', 'شلغوم العيد', 'وادي العثمانية', 'تاجنانت', 'تاسدان حدادة'],
  '44': ['عين الدفلى', 'مليانة', 'خميس مليانة', 'العبادية', 'الروينة', 'الحسانية'],
  '45': ['النعامة', 'مشرية', 'عين الصفراء', 'سفيسيفة', 'تيوت'],
  '46': ['عين تموشنت', 'بني صاف', 'العامرية', 'الحمام', 'حاسي الغلة'],
  '47': ['غرداية', 'متليلي', 'بريان', 'القرارة', 'بونورة', 'العطف'],
  '48': ['غليزان', 'وادي رهيو', 'عمي موسى', 'يلل', 'حمري', 'مازونة'],
  '49': ['المغير', 'سيدي خليل', 'سيدي عمران', 'أم الطيور'],
  '50': ['المنيعة', 'حاسي القارة', 'حاسي الفحل'],
  '51': ['أولاد جلال', 'سيدي خالد', 'الشعيبة', 'دوسن'],
  '52': ['برج باجي مختار', 'تيمياوين'],
  '53': ['بني عباس', 'القصابي', 'تابلبالة'],
  '54': ['تيميمون', 'أولاد سعيد', 'أوقروت', 'دلدول', 'شروين'],
  '55': ['تقرت', 'النزلة', 'تماسين', 'الحجيرة', 'المقارين'],
  '56': ['جانت', 'برج الحواس'],
  '57': ['عين صالح', 'فقارة الزوى'],
  '58': ['عين قزام', 'تين زاوتين'],
};

/** Get the array of commune names for a given wilaya code. */
export function getCommunes(wilayaCode) {
  return COMMUNES[wilayaCode] || [];
}
